import React from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../axiosInstance";
import axios from "axios";

const ListingSection = ({data,page,getAllInventory,setPage,totalPages,loading,error,limit}) => {
  const navigate = useNavigate()
  const handleOpen = (id) => {
    localStorage.setItem("Listing-Detail",JSON.stringify({id}))
    navigate("/ListingDetail")
  }
  const showConfirm = (onConfirm) => {
  toast.custom((t) => (
    <div style={{borderRadius:"20px"}} className="bg-white p-4 rounded-lg shadow-lg border w-64">
      <p className="text-sm font-semibold">Are you sure you want to delete?</p>

      <div style={{justifyContent:"space-around", display:"flex"}} className="flex justify-end mt-3 gap-2">
        <button
          className="px-3 ml-4 py-1 bg-gray-300 rounded"
          onClick={() => toast.dismiss(t.id)}
        >
          Cancel
        </button>

        <button
        style={{backgroundColor:"red"}}
          className="px-3 py-1 bg-red-500 text-white rounded"
          onClick={() => {
            toast.dismiss(t.id);
            onConfirm(); // run delete function
          }}
        >
          Delete
        </button>
      </div>
    </div>
  ),
  {
    duration: 10000,   // ⏳ toast stays for 10 sec
    position: "top-center"
  });
};
const handleDelete = async(id) => {
  try {
    toast.loading("Deleting...")
      const auth = JSON.parse(localStorage.getItem("auth"))
      if(!auth || !auth.token) return navigate("/")
      const response = await axiosInstance.delete(`/api/inventory/delete/${id}`,{
        headers:{
          "Authorization":auth.token
        }
      })
      toast.success(response?.data?.message)
      await getAllInventory(1,10,auth.token)
      
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          toast.error(msg);
        }
        else if (error.request) {
          toast.error("No response from server. Please check your internet connection.");
        }
        else {
          toast.error(error.message || "Unexpected error occurred.");
        }
      } else {
        toast.error("An unexpected error occurred.");
      }
    }
}
  return (
    <div className="content-column">
      <div className="inner-column">
        <div className="list-title">
          <h3 className="title">My Listings</h3>
          {error && <div className="text" style={{color:"red"}}>{error}</div>}
        </div>
        <div className="my-listing-table wrap-listing">
          <div className="cart-table">
            <div className="title-listing">
              {/* <div className="text-box v1">
                <div className="form_boxes v3">
                  <small>Sort by</small>
                  <div className="drop-menu">
                    <div className="select">
                      <span>Newest</span>
                      <i className="fa fa-angle-down" />
                    </div>
                    <input type="hidden" name="gender" />
                    <ul className="dropdown" style={{ display: "none" }}>
                      <li>Newest</li>
                      <li>Oldest</li>
                    </ul>
                  </div>
                </div>
              </div> */}
            </div>
            <div style={{overflowX:"scroll"}} >
            <table>
              <thead>
                <tr>
                  <th>Make</th>
                  <th>Tax(%) <br /> Amount($)</th>
                  <th>Model <br /> Year</th>
                  <th>Transmission <br /> Fuel Type</th>
                  <th>Color <br /> Doors</th>
                  <th>Company</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading? <tr><td colSpan={7} className="text-center">Loading...</td></tr>: data.length>0 ? data.map((obj,index)=><tr key={index}>
                  <td>
                    <div className="shop-cart-product">
                      <div className="shop-product-cart-img">
                        <img src={obj?.media[0]?.path ?obj?.media[0]?.path :"images/resource/add-car1.jpg"}   />
                      </div>
                      <div className="shop-product-cart-info">
                        <h3><a href="#" >{obj?.title}</a></h3>
                        {obj?.carDetails?.description &&<p>{obj?.carDetails?.description?.slice(0,30)}</p>}
                        <div className="price">
                          <span>${obj?.price?.totalPrice || 0}</span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span>{obj?.price?.taxPercentage && `${obj?.price?.taxPercentage}%`}</span> <br />
                    <span>{obj?.price?.amount && `$${obj?.price?.amount}`}</span>
                  </td>
                  <td>
                    <span>{obj?.carDetails?.model} <br /> {obj?.carDetails?.year}</span>
                  </td>
                  <td>
                    <span>{obj?.carDetails?.transmission} <br /> {obj?.carDetails?.fuelType}</span>
                  </td>
                  <td>
                    <span>{obj?.carDetails?.color} <br /> {obj?.carDetails?.door}</span>
                  </td>
                  <td>
                    <span>{obj?.carDetails?.company}</span>
                  </td>
                  <td >
                    <div style={{display:"flex", justifyContent:"space-between"}}  >
                    <a
                    onClick={() => {
                    showConfirm(() => {
                     handleDelete(obj._id)
                    });
                  }} 
                    className="remove-cart-item">
                      <img src="images/icons/remove.svg"   />
                    </a>
                    <a style={{marginLeft:"5px"}} className="remove-cart-item">
                      <img src="images/icons/edit.svg"   />
                    </a>
                    <a onClick={()=>handleOpen(obj._id)} href="#" className="remove-cart-item">      
                     <svg style={{color:"black"}} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g style={{color:"black"}} clip-path="url(#clip0_3114_6864)">
                                        <path d="M13.6109 0H5.05533C4.84037 0 4.66643 0.173943 4.66643 0.388901C4.66643 0.603859 4.84037 0.777802 5.05533 0.777802H12.6721L0.113697 13.3362C-0.0382246 13.4881 -0.0382246 13.7342 0.113697 13.8861C0.18964 13.962 0.289171 14 0.388666 14C0.488161 14 0.587656 13.962 0.663635 13.8861L13.222 1.3277V8.94447C13.222 9.15943 13.3959 9.33337 13.6109 9.33337C13.8259 9.33337 13.9998 9.15943 13.9998 8.94447V0.388901C13.9998 0.173943 13.8258 0 13.6109 0Z" fill="#405FF2"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_3114_6864">
                                        <rect style={{color:"black"}} width="14" height="14" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                    </a>
                    </div>
                  </td>
                </tr>):<tr><td className="text-center" colSpan={7}>No data found</td></tr>}
              </tbody>
            </table>
            </div>
            <div className="pagination-sec">
              <nav aria-label="Page navigation example">
                <ul className="pagination">

  {/* Previous Button */}
  <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
    <a
      className="page-link"
      href="#"
      onClick={(e) => {
        e.preventDefault();
        if (page > 1) setPage(page - 1);
      }}
      aria-label="Previous"
    >
      <span aria-hidden="true">
        {/* ICON */}
        <svg width={12} height={12} viewBox="0 0 12 12" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.57983 5.99992C2.57983 5.78493 2.66192 5.5699 2.82573 5.40593L7.98559 0.2462C8.31382 -0.082026 8.84598 -0.082026 9.17408 0.2462C9.50217 0.574293 9.50217 1.10635 9.17408 1.4346L4.60841 5.99992L9.17376 10.5654C9.50185 10.8935 9.50185 11.4256 9.17376 11.7537C8.84566 12.0821 8.31366 12.0821 7.98544 11.7537L2.82555 6.59407C2.66176 6.43002 2.57983 6.21498 2.57983 5.99992Z"
            fill="#050B20"
          />
        </svg>
      </span>
    </a>
  </li>

  {/* Dynamic Page Numbers */}
  {Array.from({ length: totalPages }).map((_, i) => (
    <li key={i} className={`page-item ${page === i + 1 ? "active" : ""}`}>
      <a
        className="page-link"
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setPage(i + 1);
        }}
      >
        {i + 1}
      </a>
    </li>
  ))}

  {/* Next Button */}
  <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
    <a
      className="page-link"
      href="#"
      onClick={(e) => {
        e.preventDefault();
        if (page < totalPages) setPage(page + 1);
      }}
      aria-label="Next"
    >
      <span aria-hidden="true">
        {/* ICON */}
        <svg width={12} height={12} viewBox="0 0 12 12" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.42017 6.00008C9.42017 6.21507 9.33808 6.4301 9.17427 6.59407L4.01441 11.7538C3.68618 12.082 3.15402 12.082 2.82592 11.7538C2.49783 11.4257 2.49783 10.8936 2.82592 10.5654L7.39159 6.00008L2.82624 1.43458C2.49815 1.10649 2.49815 0.574352 2.82624 0.246285C3.15434 -0.0821014 3.68634 -0.0821014 4.01457 0.246285L9.17446 5.40593C9.33824 5.56998 9.42017 5.78502 9.42017 6.00008Z"
            fill="#050B20"
          />
        </svg>
      </span>
    </a>
  </li>

</ul>
                {/* <div className="text">Showing results 1-30 of 1,415</div> */}
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListingSection;
